import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { PlusOutlined } from "@ant-design/icons";

import { groupListLoad } from 'store/models/group';
import { tableColumn } from 'utils';
import { TableList, ActionButton, Image } from 'components/common';
import { GroupValue } from 'components/blocks/Group';


const PluginDataGroupList = ({ detail, fieldName, items, extIds, actions, site, plugin, authToken }) => {
  //const [loading, setLoading] = useState(false);
  const [innerItems, setInnerItems] = useState([]);

  const apiLoad = groupListLoad(site.activeDomain);
  const ext_ids = extIds.join(',');

  useEffect(() => {
    let _isSubscribed = true;
    console.log(ext_ids);

    //setLoading(true);
    apiLoad(authToken, { activeFilter: {ext_id: ext_ids} }).then(({ error, data }) => {
      if (_isSubscribed) {
        //setLoading(false);
        if (!error) {
          console.log('data', data);
          const byExtId = data.results.reduce((res, item) => {
            res[item.ext_id] = item;
            return res;
          }, {})
          
          setInnerItems(items.reduce((res, item) => {
            if (byExtId[item.ext_id]) {
              byExtId[item.ext_id].index = item.index;
              res.push(byExtId[item.ext_id])
            }
            return res;
          }, []));
        }
      }
    });

    return () => (_isSubscribed = false);
  // eslint-disable-next-line
  }, [ext_ids]);

  const columnList = ['image', 'name', 'actions'];

  const addItem = () => {
    actions.plugin.showDataItemForm({ 
      show: true, 
      preventLoadDetail: true,
      detail, 
      itemFieldType: 'product_list',
      itemFieldName: fieldName,
      itemFields: [
        {
          'name': 'ext_id',
          'label': 'Группа товаров',
          'type': 'group',
          'default': null,
          'required': true,
        },
      ]
    });
  };

  const delItem = (item) => {
    console.log('delItem', item);
    const _tmpItems = innerItems.map(item => item.ext_id);
    _tmpItems.splice(item.index, 1);
    const data = Object.assign(detail.data, {
      [fieldName]: _tmpItems,
    });

    const postData = {
      id: detail.id,
      site: site.activeId,
      data:  data,
      preventLoadDetail: true,
    };

    console.log('postData', postData);
    actions.plugin.update(postData);
  };

  const columnByName = {
    ext_id: tableColumn('Группа товаров', 'ext_id', {
      render: (val, item) => <GroupValue detail={item} asLink={true} isBack={true} />,
      sorter: false,
    }),
    name: tableColumn('Название', 'name', {
      render: (val, item) => (
        <div>
          <GroupValue detail={item} asLink={true} isBack={true} />
          <div>Артикул: {item.art_no}</div>
          <div>Активно: {item.product_count}</div>
        </div>
      ),
      sorter: true,
    }),
    image: tableColumn('Картинка', 'image', {
      render: (val, item) => {
        const img = item.images[0];
        return <Image src={img && img.url} width={120} height={100} />;
      },
      width: 120,
      sorter: true,
    }),

    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton 
          detail={item} 
          modelActions={actions.plugin} 
          actions={[{ name: 'edit' }, { name: 'delete' }]}
          actionByName={{
            edit: (modelActions, item) => ({
              title: 'Редактировать',
              action: () => actions.plugin.showDataItemForm({ 
                show: true, 
                detail, 
                item, 
                itemFieldType: 'product_list',
                itemFieldName: fieldName, 
                itemFields: [
                  {
                    'name': 'ext_id',
                    'label': 'Группа товаров',
                    'type': 'group',
                    'default': null,
                    'required': true,
                  },
                ]
              }),
            }),
            delete: (modelActions, item) => ({
              title: 'Удалить',
              action: () => delItem(item),
            }),
          }}
        />
      ),
    }),
  };

  return (
    <TableList
      dataSource={innerItems}
      model={plugin}
      columnList={columnList}
      columnByName={columnByName}
      topActions={[
        <Button type="primary" icon={<PlusOutlined/>} onClick={addItem}>Добавить</Button>
      ]}
      showSearch={false}
      hideNav={true}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  site: state.site,
  plugin: state.plugin,
});

const mapDispatch = (dispatch) => ({
  actions: {
    plugin: dispatch.plugin,
  },
});

export default connect(mapState, mapDispatch)(PluginDataGroupList);
